import { ironBuildVersionIsV4 } from '@app/utils';

import v3Provider from './HelmetProvider.v3';
import v4Provider from './HelmetProvider.v4';

export default ironBuildVersionIsV4 ? v4Provider : v3Provider;
